import { getClassifyConfig } from './config';
import * as classify from '@amzn/awsdataplatform-classify-client';

const config = getClassifyConfig();
let classificationClient = new classify.DataPlatformClassifyClient();

// Initialize client with credentials
export async function initClassificationClient(credentials: any) {
  const clientConfig: classify.DataPlatformClassifyClientConfig = {
    region: config.region,
    endpoint: config.endpoint,
    credentials: credentials,
  };
  classificationClient = new classify.DataPlatformClassifyClient(clientConfig);
}

export const getClassification = (input: classify.GetClassificationCommandInput) => {
  return classificationClient.send(new classify.GetClassificationCommand(input));
};

export const updateClassification = (input: classify.UpdateClassificationCommandInput) => {
  return classificationClient.send(new classify.UpdateClassificationCommand(input));
};

export const listClassifications = (input: classify.ListClassificationsCommandInput) => {
  return classificationClient.send(new classify.ListClassificationsCommand(input));
};
